import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import './index.css'
import App from './App.tsx'

// We'll use CSS imports for fonts instead of JS imports

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <div className="cyber-grid"></div>
      <div className="scanline"></div>
      <App />
    </BrowserRouter>
  </StrictMode>,
)
